import { render, staticRenderFns } from "./ClassicCaseInfo.vue?vue&type=template&id=b2c76fa8&"
import script from "./ClassicCaseInfo.vue?vue&type=script&lang=js&"
export * from "./ClassicCaseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports